// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckBox_container__127i_","disabled":"CheckBox_disabled__26RJ1","checkmark":"CheckBox_checkmark__I-_WR"};